import { __assign } from "tslib";
import { partition } from './hierarchy/partition';
import { treemap } from './hierarchy/treemap';
/**
 * sunburst 处理数据
 * @param options
 */
export function transformData(options) {
    var data = options.data, type = options.type, seriesField = options.seriesField, colorField = options.colorField, hierarchyConfig = options.hierarchyConfig;
    var transform = {
        partition: partition,
        treemap: treemap,
    };
    var nodes = transform[type](data, __assign(__assign({}, hierarchyConfig), { 
        // @ts-ignore
        type: "hierarchy." + type, field: seriesField, as: ['x', 'y'] }));
    var result = [];
    nodes.forEach(function (node) {
        var _a;
        var _b, _c;
        if (node.depth === 0) {
            return null;
        }
        var nodeInfo = __assign((_a = {}, _a[seriesField] = (_b = node.data) === null || _b === void 0 ? void 0 : _b[seriesField], _a[colorField] = (_c = node.data) === null || _c === void 0 ? void 0 : _c[colorField], _a), node);
        nodeInfo.ext = hierarchyConfig;
        if (!node.data.brand && node.parent) {
            nodeInfo.brand = node.parent.data.brand;
        }
        else {
            nodeInfo.brand = node.data.brand;
        }
        result.push(nodeInfo);
    });
    return result;
}
//# sourceMappingURL=utils.js.map